import React, { FC } from 'react';
import classNames from 'classnames';

export const NavBarContent: FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={classNames([className, 'tw-flex tw-flex-1 tw-justify-between tw-ml-8 xl:tw-ml-0 tw-overflow-hidden xl:tw-overflow-visible'])}>{children}</div>
);
